import { render, staticRenderFns } from "./xmlRobot.vue?vue&type=template&id=3162dd56&scoped=true&"
import script from "./xmlRobot.vue?vue&type=script&lang=js&"
export * from "./xmlRobot.vue?vue&type=script&lang=js&"
import style0 from "./xmlRobot.vue?vue&type=style&index=0&id=3162dd56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162dd56",
  null
  
)

export default component.exports